import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UserResponseSchema, UserProfileUpdateInput } from '@app/core/api/user';

export const UserActions = createActionGroup({
  source: 'User',
  events: {
    // Load user profile
    'Load Profile': emptyProps(),
    'Load Profile Success': props<{ profile: UserResponseSchema }>(),
    'Load Profile Failure': props<{ error: string }>(),

    // Create or sync user
    'Create Or Sync': emptyProps(),
    'Create Or Sync Success': props<{ profile: UserResponseSchema }>(),
    'Create Or Sync Failure': props<{ error: string }>(),

    // Update user profile
    'Update Profile': props<{ data: UserProfileUpdateInput }>(),
    'Update Profile Success': props<{ profile: UserResponseSchema }>(),
    'Update Profile Failure': props<{ error: string }>(),

    // Delete personal data
    'Delete Personal Data': emptyProps(),
    'Delete Personal Data Success': emptyProps(),
    'Delete Personal Data Failure': props<{ error: string }>(),

    // Delete account
    'Delete Account': emptyProps(),
    'Delete Account Success': emptyProps(),
    'Delete Account Failure': props<{ error: string }>(),

    // Set profile (used by auth effects)
    'Set Profile': props<{ profile: UserResponseSchema }>(),

    // Clear profile (used on logout)
    'Clear Profile': emptyProps(),

    // Invalidate cache
    'Invalidate Cache': emptyProps(),
  }
});
